<app-header></app-header>

<router-outlet></router-outlet>

<simple-notifications></simple-notifications>
